<template>
  <aha-modal
    @hide="$emit('closeThanksModal')"
    width="400px"
    :title="$i18nPresenter.t('Request received')"
    :iconBeforeModalTitle="iconBeforeModalTitle"
    :no-margin-padding="true"
  >
    <div class="pl-6 pr-6 pb-8 relative pricing-container-v3">
      <div>
        {{ $i18nPresenter.t("A sales representative will be in touch within 48 hours. Thanks for your interest!") }}
      </div>
      <div class="flex justify-end mt-4">
        <aha-button
          variant="base"
          @click="$emit('closeThanksModal')"
        >
          {{ $i18nPresenter.t('Done') }}
        </aha-button>
      </div>
    </div>
  </aha-modal>
</template>
<script >

export default {
  data() {
    return {
      iconBeforeModalTitle: {
        name: 'received-checked',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        maintainColor: true,
      },
    }
  },
}
</script>
<style lang="scss" scoped>
.modal-close {
    right: 16px !important;
    top: 16px !important;
    position: absolute;
    width: 24px;
    height: 24px;
    color: #555;
    cursor: pointer;
    border: 0;

    &:hover {
      color: #348ef6;
    }
  }
</style>
